import * as msal from '@azure/msal-browser';

const msalConfig = {
  // authority: `https://login.microsoftonline.com/organizations/${process.env.REACT_APP_MS_AUTHORITY}`,
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/organizations/',
    redirectUri: process.env.REACT_APP_MS_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

const hasAzureLogout = (currentSession) => {
  if (currentSession
      && currentSession.attributes
      && currentSession.attributes.divisionSettings
      && currentSession.attributes.hasSso
  ) {
    return currentSession.attributes.divisionSettings.some(setting => (setting.settingName === 'logout_azure_ad'));
  }
  return false;
};

const clientApp = new msal.PublicClientApplication(msalConfig);

const azureLogout = () => {
  clientApp.logoutRedirect({
    postLogoutRedirectUri: '/',
    mainWindowRedirectUri: '/',
  });
};

const loginRequest = {
  // User.read is the permission needed to get the user's email
  scopes: ['User.Read'],
};

export { clientApp as default, loginRequest, azureLogout, hasAzureLogout };
